import "./profiles.scss";

document.addEventListener("DOMContentLoaded", () => {
	initProfiles();
});

function lockScroll(lock) {
	document.documentElement.classList.toggle("is-locked", lock);
}

function formatBio(text) {
	// Convert plain text into paragraphs similar to wpautop
	const lines = String(text || "")
		.trim()
		.split(/\n{2,}/g);
	return lines
		.map((p) => `<p>${escapeHtml(p).replace(/\n/g, "<br>")}</p>`)
		.join("");
}

function escapeHtml(str) {
	return String(str)
		.replaceAll("&", "&amp;")
		.replaceAll("<", "&lt;")
		.replaceAll(">", "&gt;")
		.replaceAll('"', "&quot;")
		.replaceAll("'", "&#039;");
}

export default function initProfiles() {
	document.querySelectorAll(".profiles").forEach((block) => {
		const modal = block.querySelector(".profiles-lightbox");
		if (!modal) return;

		const imgEl = modal.querySelector(".js-profile-modal-image");
		const roleEl = modal.querySelector(".js-profile-modal-role");
		const nameEl = modal.querySelector(".js-profile-modal-name");
		const bioEl = modal.querySelector(".js-profile-modal-bio");

		let lastFocus = null;

		function openModal(trigger) {
			lastFocus = document.activeElement;

			const name = trigger.dataset.name || "";
			const role = trigger.dataset.role || "";
			const image = trigger.dataset.image || "";
			const bio = trigger.dataset.bio || "";

			imgEl.src = image;
			imgEl.alt = name;

			roleEl.textContent = role;
			nameEl.textContent = name;
			bioEl.innerHTML = formatBio(bio);

			modal.classList.add("is-open");
			modal.setAttribute("aria-hidden", "false");
			lockScroll(true);

			const closeBtn = modal.querySelector(".profiles-lightbox--close");
			closeBtn && closeBtn.focus();
		}

		function closeModal() {
			modal.classList.remove("is-open");
			modal.setAttribute("aria-hidden", "true");
			lockScroll(false);

			// cleanup image to stop downloads if quickly closing
			imgEl.src = "";

			if (lastFocus && typeof lastFocus.focus === "function")
				lastFocus.focus();
		}

		block.querySelectorAll(".js-profile-open").forEach((btn) => {
			btn.addEventListener("click", () => openModal(btn));
		});

		modal.querySelectorAll(".js-profile-close").forEach((el) => {
			el.addEventListener("click", closeModal);
		});

		document.addEventListener("keydown", (e) => {
			if (!modal.classList.contains("is-open")) return;
			if (e.key === "Escape") closeModal();
		});
	});
}
